module.exports = __webpack_public_path__ + "img/lux.c858787c.svg";